import { get, post } from '../../utils/http';

// Applicants to every supplier shift this project ordered.
export const fetchProjectOrderApplicants = ({ accountId, branchId, projectId }) =>
  get(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/order-applicants`);

export const bookProjectOrderApplicants = ({
  accountId,
  branchId,
  projectId,
  supplierShiftId,
  employeeIds,
  bypassComplianceWarnings
}) =>
  post(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/order-applicants/book`, {
    supplierShiftId,
    employeeIds,
    ...(bypassComplianceWarnings && { bypassComplianceWarnings })
  });
